import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../App";
import { User, Lock, ArrowRight, Loader2, Shield, Eye, EyeOff, Headphones, KeyRound } from "lucide-react";
import { Button } from "../components/ui/button";
import PrimeiroAcesso from "../components/PrimeiroAcesso";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export const SUPORTE_URL = "https://wa.me/447451267616";

export default function Login() {
  const [usuario, setUsuario] = useState("");
  const [senha, setSenha] = useState("");
  const [verSenha, setVerSenha] = useState(false);
  const [primeiro, setPrimeiro] = useState(false);
  const { login, loading, trocarCondominio, entrarComResposta } = useAuth();
  const [escolher, setEscolher] = useState(null); // síndico de vários condomínios
  const [resposta, setResposta] = useState(null);
  const [indo, setIndo] = useState(null);
  const irPara = async (c) => {
    setIndo(c.id);
    try {
      if (c.id === resposta?.condominio?.id) { entrarComResposta(resposta, false); navigate("/"); }
      else await trocarCondominio(c.id);
    } catch { setIndo(null); }
  };
  const navigate = useNavigate();

  const entrar = async (e) => {
    e.preventDefault();
    if (!usuario.trim() || !senha) return;
    const r = await login(usuario.trim(), senha);
    if (!r.success) return;
    if (r.resposta) { setResposta(r.resposta); setEscolher(r.condominios); }
    else navigate("/");
  };

  return (
    <div className="min-h-screen flex">
      <div className="flex-1 flex items-center justify-center p-6 sm:p-8 bg-white">
        <div className="w-full max-w-sm space-y-8">
          <div className="text-center">
            <div className="inline-flex items-center justify-center w-24 h-24 bg-slate-900 rounded-3xl mb-5 shadow-lg">
              <img src="/lobo-laranja.png" alt="" className="w-20 h-20 object-contain" />
            </div>
            <h1 className="font-heading text-4xl text-slate-900 tracking-tight">SISTEMA DE ENCOMENDAS</h1>
            <p className="mt-1 text-slate-500">Portaria e moradores, tudo registrado</p>
          </div>

          {escolher ? (
            <div className="space-y-3" data-testid="escolher-condominio">
              <p className="text-center font-heading text-2xl text-slate-900">ESCOLHA O CONDOMÍNIO</p>
              <p className="text-center text-sm text-slate-500 -mt-2">Você pode trocar depois, tocando no nome do condomínio no topo.</p>
              {escolher.map((c) => (
                <button key={c.id} type="button" onClick={() => irPara(c)} disabled={!!indo}
                  className="w-full flex items-center justify-between gap-3 p-4 rounded-xl border-2 border-slate-200 hover:border-orange-500 text-left"
                  data-testid={`escolher-${c.codigo}`}>
                  <span className="font-semibold text-slate-900">{c.nome}</span>
                  {indo === c.id ? <Loader2 className="w-4 h-4 animate-spin" /> : (
                    <span className={`shrink-0 text-xs font-bold px-2.5 py-1 rounded-full ${c.pendentes ? "bg-orange-100 text-orange-700" : "bg-green-100 text-green-700"}`}>
                      {c.pendentes} pendente{c.pendentes === 1 ? "" : "s"}
                    </span>
                  )}
                </button>
              ))}
            </div>
          ) : primeiro ? (
            <PrimeiroAcesso onVoltar={() => setPrimeiro(false)} onPronto={() => navigate("/")} />
          ) : (<>
          <form onSubmit={entrar} className="space-y-5">
            <div className="space-y-2">
              <Label htmlFor="usuario" className="text-slate-700 font-medium">Usuário</Label>
              <div className="relative">
                <User className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
                <Input
                  id="usuario"
                  autoComplete="username"
                  autoCapitalize="none"
                  autoCorrect="off"
                  placeholder="ex.: flores-usuario"
                  value={usuario}
                  onChange={(e) => setUsuario(e.target.value.toLowerCase().replace(/\s/g, ""))}
                  className="pl-11 h-12 text-base border-slate-300"
                  required
                  data-testid="input-usuario"
                />
              </div>
            </div>

            <div className="space-y-2">
              <Label htmlFor="senha" className="text-slate-700 font-medium">Senha</Label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
                <Input
                  id="senha"
                  type={verSenha ? "text" : "password"}
                  autoComplete="current-password"
                  inputMode="text"
                  placeholder="Sua senha"
                  value={senha}
                  onChange={(e) => setSenha(e.target.value)}
                  className="!pl-11 !pr-11 h-12 text-base border-slate-300"
                  required
                  data-testid="input-senha"
                />
                <button
                  type="button"
                  onClick={() => setVerSenha(!verSenha)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600"
                  aria-label={verSenha ? "Esconder senha" : "Mostrar senha"}
                >
                  {verSenha ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                </button>
              </div>
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full h-12 bg-slate-900 hover:bg-slate-800 text-white font-semibold text-base"
              data-testid="btn-entrar"
            >
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : (<>Entrar <ArrowRight className="w-5 h-5 ml-2" /></>)}
            </Button>
          </form>

          <button
            type="button"
            onClick={() => setPrimeiro(true)}
            className="w-full flex items-center gap-3 p-3 rounded-xl border-2 border-dashed border-orange-300 bg-orange-50 hover:bg-orange-100 text-left"
            data-testid="btn-primeiro-acesso"
          >
            <KeyRound className="w-6 h-6 text-orange-500 shrink-0" />
            <span>
              <span className="block font-semibold text-slate-900">Primeiro acesso?</span>
              <span className="block text-xs text-slate-600">Ainda não tem usuário e senha? Entre com o código do condomínio e o seu e-mail.</span>
            </span>
          </button>
          </>)}

          <div className="space-y-3 border-t border-slate-200 pt-6">
            <div className="flex items-center justify-center gap-5 text-sm font-medium">
              <Link to="/esqueci-senha" className="text-slate-600 hover:text-slate-900" data-testid="link-esqueci">Esqueci minha senha</Link>
              <a href={SUPORTE_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 text-green-700 hover:text-green-800">
                <Headphones className="w-4 h-4" /> Suporte
              </a>
            </div>
            <Link to="/admin" className="flex items-center justify-center gap-2 text-slate-400 hover:text-slate-600 text-xs">
              <Shield className="w-3.5 h-3.5" /> Acesso Administrador
            </Link>
          </div>
        </div>
      </div>

      <div className="hidden lg:block lg:flex-1 relative bg-slate-900">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-800 to-orange-900/60" />
        <div className="relative h-full flex items-center justify-center p-12">
          <div className="text-center text-white">
            <h2 className="font-heading text-5xl mb-4">CONTROLE TOTAL</h2>
            <p className="text-xl text-slate-300 max-w-md">
              Registre encomendas, entregue com segurança e avise os moradores automaticamente.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
